import React,{useState} from "react";
import {CaretDoubleLeft, CaretDoubleRight, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert } from "react-bootstrap";


export default function Pagination(props) {
	
	const [currentPage,setCurrentPage]				= useState(props.currentPage);
	const [rowsPerPage,setRowsPerPage]				= useState(props.rowsPerPage);
	
	const rowsperpage = [10, 20, 50, 100];
	
	const pages  = Math.ceil(props.rowCount/props.rowsPerPage);
	
	
	const from = (currentPage-1)*rowsPerPage + 1 ;
	const to = currentPage*rowsPerPage > props.rowCount ? props.rowCount : currentPage*rowsPerPage;
	
	
	const firstPage = function(){
		setCurrentPage(1);
		props.onChangePage(1);
	}
	const lastPage = function(){
		setCurrentPage(pages);
		props.onChangePage(pages);
	}
	const next = function(){
		
		if(currentPage >= pages)
			return;
		
		props.onChangePage(currentPage+1);
		setCurrentPage(currentPage+1);
		
	}
	const previous = function(){
		
		if(currentPage <= 1)
			return;
		
		props.onChangePage(currentPage-1);
		setCurrentPage(currentPage-1);
	}
	const changeRows = function(ev){
		
		props.onChangeRowsPerPage(ev.target.value);
		setRowsPerPage(ev.target.value);
	}
	
	
	
	
	
	const nextAvailable = currentPage < pages;
	const prevAvailable = currentPage > 1;

		
	return (
		<Row className="pagination">
			<Col className="showing">
				Showing <b>{from}</b> to <b>{to}</b> of <b>{props.rowCount}</b> {props.paginationComponentOptions.type ?? 'items'}
			</Col>
			{pages > 1 &&
			<Col className="text-center">
				<Button className="first-page" disabled={!prevAvailable} onClick={firstPage}> <CaretDoubleLeft size={16} /></Button>
				<Button disabled={!prevAvailable} onClick={previous}> <CaretLeft size={16} /></Button>
				
				<div className="pages">Page <b>{currentPage}</b> of <b>{pages}</b> </div>
				
				<Button disabled={!nextAvailable} onClick={next}> <CaretRight size={16} /></Button>
				<Button className="last-page" disabled={!nextAvailable} onClick={lastPage}> <CaretDoubleRight size={16} /></Button>
			</Col>
			}
			<Col className="text-end">
				{!props.paginationComponentOptions.hideRowsPerPage &&
					<>
						{props.paginationComponentOptions.rowsPerPageText}:
						<Form.Select onChange={changeRows} value={props.rowsPerPage} className="form-control">
							{rowsperpage.map((i)=>{
								return <option value={i} key={i} >{i}</option>
							})}
						</Form.Select>
					</>
				}
			</Col>
		</Row>
	)
}